import { Component, Input, OnChanges } from '@angular/core';
import { ChartConfiguration } from 'chart.js';
import { MonthlyDataPoint } from '../../../../services/user-analytics/user-analytics.model';

@Component({
    selector: 'app-user-card-registrations-trend',
    templateUrl: './user-card-registrations-trend.component.html',
    styleUrls: ['./user-card-registrations-trend.component.scss'],
})
export class UserCardRegistrationsTrendComponent implements OnChanges {
    @Input() data: MonthlyDataPoint[] = [];

    chartData: ChartConfiguration<'line'>['data'] = { labels: [], datasets: [] };

    chartOptions: ChartConfiguration<'line'>['options'] = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: {
            x: { grid: { display: false } },
            y: { beginAtZero: true, ticks: { precision: 0 } },
        },
        elements: {
            point: { radius: 3, hoverRadius: 5 },
            line: { tension: 0.3 },
        },
    };

    ngOnChanges(): void {
        if (!this.data || this.data.length === 0) return;
        this.chartData = {
            labels: this.data.map((p) => this.formatMonth(p.month)),
            datasets: [
                {
                    data: this.data.map((p) => p.count),
                    borderColor: '#10b981',
                    backgroundColor: '#10b98120',
                    pointBackgroundColor: '#10b981',
                    pointBorderColor: '#10b981',
                    fill: true,
                },
            ],
        };
    }

    private formatMonth(month: string): string {
        const [year, m] = month.split('-');
        const date = new Date(+year, +m - 1);
        return date.toLocaleDateString(undefined, { month: 'short', year: '2-digit' });
    }
}
